module.exports = __webpack_public_path__ + "static/media/freezone.1dd7d914.jpeg";